import React, { useContext } from 'react';
import styled from 'styled-components';

import { DebugDiv } from '../../../../../components/Debug';
import { ButtonPosition, ButtonPositionContext, MenuItem } from '../Console';
import { ButtonTypes, formatLabel, MenuButtonContainer, MenuButtonProps } from '../MenuButton';

const RightGrayPatch = styled.div`
  width: 20px;
  height: 10px;
  position: absolute;
  top: -2px;
  right: 2px;
  z-index: 4;
  font-weight: bold;
`;

const LeftGrayPatch = styled.div`
  width: 20px;
  height: 10px;
  position: absolute;
  top: -2px;
  left: 0px;
  z-index: 4;
  font-weight: bold;
`;

const NavigationButton = ({ item, buttonIdentifier }: MenuButtonProps) => {
  const contextValue = useContext(ButtonPositionContext);

  return (
    <MenuButtonContainer>
      {item.type === ButtonTypes.NavigationButtonNext && (
        <>
          <RightGrayPatch>...</RightGrayPatch>
        </>
      )}
      {item.type === ButtonTypes.NavigationButtonPrev && (
        <>
          <LeftGrayPatch>...</LeftGrayPatch>
        </>
      )}
      <DebugDiv>{buttonIdentifier}</DebugDiv>
      {formatLabel(item.label)}
    </MenuButtonContainer>
  );
};

export default NavigationButton;
